var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-navbar'),_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_vm._v("\n        Page Mails\n      ")])],1),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }